import track from 'c9-tracking';
import { format, getDay, parse } from 'date-fns';
import { NavigationState } from '../store/navigation.type';
import { convertToIsoTime, DATE_FORMAT, ISO_DATE_FORMAT, weekdays } from '../utils/date-utils';
import { determineSelectionFromPath } from './area';
import { isScheduledBooking } from './callback-whitelist';
import {
  getCopenhagenTimeOffsetInMins,
  getLocalTimeOffsetInMin,
  isLocalTimeZoneSameAsCopenhagenTimeZone,
} from './timezone';

export const trackConversion = (navigation: NavigationState) => {
  const items = [
    { key: 'area', value: navigation.area! },
    { key: 'initial-area', value: determineSelectionFromPath() },
    { key: 'category', value: navigation.category as string },
  ];

  if (navigation.category === 'insurance' || navigation.category === 'injury' || navigation.category === 'others') {
    const { comment, ...rest } = navigation.selections[navigation.category];
    const selection = {
      ...rest,
      hasComment: !!comment?.trim(),
    };

    Object.entries(selection)
      .map(([key, value]) => ({
        key: `sub-category-${key}`,
        value: typeof value === 'object' ? JSON.stringify(value) : value,
      }))
      .forEach((item) => items.push(item));
  }

  if (isScheduledBooking(navigation)) {
    items.push({
      key: 'booking option',
      value: 'selected time',
    });

    // isScheduledBooking ensures bookingDate is not undefined
    const date = parse(navigation.bookingDate!, DATE_FORMAT, new Date());

    [
      { key: 'scheduled-date', value: format(date, ISO_DATE_FORMAT) },
      // isScheduledBooking ensures bookingTime is not undefined
      { key: 'scheduled-time', value: convertToIsoTime(navigation.bookingTime!) },
      { key: 'scheduled-day', value: weekdays[getDay(date)] },
    ].forEach((item) => items.push(item));
  } else {
    items.push({
      key: 'booking option',
      value: 'soonest',
    });
  }

  if (
    isScheduledBooking(navigation) &&
    ((navigation.category === 'insurance' && navigation.selections.insurance.reviewInsurance) ||
      (navigation.category === 'others' && navigation.selections.others.reviewInsurance))
  )
    items.push({ key: 'review', value: 'true' });

  track.convert(items);
};

export const trackTimeZoneDifference = () => {
  const now = new Date();

  track.info([
    {
      key: 'danish-time',
      value: getCopenhagenTimeOffsetInMins(now) / 60,
    },
    {
      key: 'user-time',
      value: getLocalTimeOffsetInMin(now) / 60,
    },
    {
      key: 'same-timezone-as-denmark',
      value: isLocalTimeZoneSameAsCopenhagenTimeZone(),
    },
  ]);
};
